import LeaveFeedback from "@/v2-components/pages/software/components/LeaveFeedback";

export default function LiveFeedbackSection() {
  return (
    <section className="w-full bg-white">
      <div className="mx-auto w-full max-w-[1440px] px-4">
        <LeaveFeedback
          platform="LIVE"
          imageSrc="/images/software/shared/leave_feedback_desktop@2x.png"
          mobileImageSrc="/images/software/shared/leave_feedback_mobile@2x.webp"
        />
      </div>
    </section>
  );
}
